import styled from 'styled-components'
import { Theme } from '@cubeyou-team/hx-theme'

export const StyledItemInfoBox = styled.div`
  width: 100%;
  padding: ${(props: { theme: Theme }) => props.theme.spacing.medium};
  box-shadow: ${(props: { theme: Theme }) => props.theme.shadow.position}
    ${(props) => props.theme.shadow.color};
  background-color: ${(props: { theme: Theme }) => props.theme.colors.light};
  position: relative;
  border-radius: ${(props: { theme: Theme }) => props.theme.border_radius.standard};
`

export const StyledCloseButtonContainer = styled.div`
  position: absolute;
  top: ${(props: { theme: Theme }) => props.theme.spacing.medium};
  right: ${(props: { theme: Theme }) => props.theme.spacing.medium};
`

export const ShowLessOrMoreButton = styled.span<{ more: boolean }>`
  color: ${(props: { theme: Theme }) => props.theme.colors.secondary};
  font-weight: bold;
  cursor: pointer;
  padding-left: ${(props) => (props.more ? '0px' : '5px')};
`
